import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Spin } from 'antd';
import HeaderNav from '@containers/layout/HeaderNav';
import Login from '@pages/Login';
import ClientsPage from '@pages/Clients';
import RequestsPage from '@pages/Requests';
import CouponsPage from '@pages/Coupons';
import UsersPage from '@pages/Users';
import RegionsPage from '@pages/Regions';
import PropertiesPage from '@pages/Properties';
import PdfViewPage from '@pages/PdfView';
import AppActions, { AppSelectors } from '@redux/AppRedux';
import { AuthSelectors } from '@redux/AuthRedux';

import '@styles/main.less';

class App extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    startup: PropTypes.func,
    isLoggedIn: PropTypes.bool
  };

  componentDidMount() {
    const { startup } = this.props;

    startup();
  }

  renderAnonRoutes() {
    return (
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route render={() => <Redirect to="/login" />} />
      </Switch>
    );
  }

  renderUserRoutes() {
    return (
      <div style={{ height: '100vh', overflowX: 'scroll' }}>
        <HeaderNav />
        <Switch>
          <Route path="/clients" component={ClientsPage} />
          <Route path="/coupons" component={CouponsPage} />
          <Route path="/properties" component={PropertiesPage} />
          <Route path="/users" component={UsersPage} />
          <Route path="/regions" component={RegionsPage} />
          <Route path="/requests" component={RequestsPage} />
          <Route exact path="/pdf" component={PdfViewPage} />
          <Route render={() => <Redirect to="/clients" />} />
        </Switch>
      </div>
    );
  }

  renderContent() {
    const { loaded, loading, isLoggedIn } = this.props;

    if (!loaded || loading) {
      return <Spin />;
    }

    if (!isLoggedIn) {
      return this.renderAnonRoutes();
    }

    return this.renderUserRoutes();
  }

  render() {
    return this.renderContent();
  }
}

const mapStatesToProps = state => ({
  loading: AppSelectors.selectLoading(state),
  loaded: AppSelectors.selectLoaded(state),
  isLoggedIn: AuthSelectors.selectIsLoggedIn(state)
});

const mapDispatchToProps = dispatch => ({
  startup: () => dispatch(AppActions.startup())
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(App);
